import {initElements} from "../define/shared"

export default function initHeader() {
    initElements(".siteHeader", header => {
        const menu = header.querySelector(".siteHeader-menu"),
            menuItems = header.querySelector(".siteHeader-menu-items"),
            blocksWithTitle = [].slice.apply(document.querySelectorAll("[data-block-title]")),
            humb = header.querySelector('.siteHeader-humb')

        blocksWithTitle.forEach(block => {
            const title = block.dataset.blockTitle;

            if (title) {
                const menuItem = document.createElement("li"),
                    a = document.createElement("a");

                a.innerText = title;
                a.href = "#";
                a.setAttribute('data-anchor-link', title)

                menuItems.appendChild(menuItem);
                menuItem.appendChild(a);
            }
        });

        const anchorLinks = [].slice.apply(document.querySelectorAll("[data-anchor-link]"))

        anchorLinks.forEach(link => {
            link.addEventListener("click", event => {
                event.preventDefault();

                window.scrollTo({
                    left: 0,
                    top: document.querySelector(`[data-block-title="${link.dataset.anchorLink}"]`).offsetTop - header.offsetHeight - 10,
                    behavior: "smooth"
                });
            });
        })

        window.addEventListener('scroll', () => {
            window.pageYOffset > 0 ? header.classList.add('onscroll') : header.classList.remove('onscroll')
        })

        humb.addEventListener('click', () => {
            menu.classList.toggle('is--open')
            humb.classList.toggle('is--open')
        })
    })
}
